
import { Box, Grid, TextField, FormControlLabel, TextareaAutosize, Button, IconButton } from '@mui/material'
import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useCallback, useMemo, useEffect, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from "react-i18next";
import Logo from '../../../Media/Upload.jpeg';
import axios from '../../../utils/fvAxios';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import useFetch from "../../../utils/useFetch";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import CancelIcon from "@mui/icons-material/Cancel";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { RFC_2822 } from 'moment';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

export default function EditTemplate({ TemplatesList, CLOSETAB, DETAILS, ID, Languages, SHOWS }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'background',
        'list',
        'align',
        // 'link',
        // 'image',
        'color',
        'indent',
        'clean',
        'blockquote', 'script'

    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],

            ['clean'],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };

    const Emaildata = [
        {
            key: 15,
            value: "BusinessUnit",
            is: false
        },
        {
            key: 3,
            value: "ClientName",
            is: false
        },
        {
            key: 6,
            value: "CustomerServicePhone",
            is: false
        },
        {
            key: 7,
            value: "CustomerServiceEmail",
            is: false
        },
        {
            key: 11,
            value: "CurrentYear",
            is: false
        },
        {
            key: 8,
            value: "DocumentName",
            is: false
        },
        {
            key: 1,
            value: "Date",
            is: false
        },
        {
            key: 9,
            value: "ExpirationDate",
            is: false
        },
        {
            key: 13,
            value: "EmployeeName",
            is: false
        },
        {
            key: 17,
            value: "FirstName",
            is: false
        },
        {
            key: 12,
            value: "PreviousYear",
            is: false
        },
        {
            key: 14,
            value: "PQStatus",
            is: false
        },
        {
            key: 10,
            value: "ReviewApprovalLink",
            is: false
        },
        {
            key: 4,
            value: "SuperClient",
            is: true
        },
        {
            key: 5,
            value: "SubClient",
            is: true
        },
        {
            key: 2,
            value: "VendorName",
            is: false
        },
        {
            key: 16,
            value: "Location/Project",
            is: false
        },
        {
            key: 18,
            value: "LastName",
            is: false
        },
        {
            key: 19,
            value: "ScoreCardThresholdLimit",
            is: false
        }
    ]
    const InvitationFields = [
        {
            key: 1,
            value: "ClientName"
        },
        {
            key: 2,
            value: "Client_UserName"
        },
        {
            key: 3,
            value: "URL"
        },
        {
            key: 4,
            value: "VendorName"
        },
        {
            key: 5,
            value: "Client_EmailAddress"
        },
        {
            key: 6,
            value: "Location_Name"
        },
        {
            key: 7,
            value: "Vendor_RiskLevel"
        },
        {
            key: 8,
            value: "Client_Comments"
        },
        {
            key: 9,
            value: "Risk_LevelFee"
        },
        {
            key: 10,
            value: "Vendor_FirstLastNames"
        },
        {
            key: 11,
            value: " Vendor_EmailAddress"
        },
        {
            key: 12,
            value: " SuperClient_Name"
        },
        {
            key: 13,
            value: "Invitation_Code"
        },
        {
            key: 14,
            value: "Vendor_FirstName"
        },
        {
            key: 15,
            value: "Vendor_LastName"
        },
        {
            key: 16,
            value: "Client_Code"
        },
        {
            key: 17,
            value: "Date"
        },
        {
            key: 18,
            value: "SuperClient_Name"
        },
        {
            key: 19,
            value: "Template_Code"
        },
        {
            key: 20,
            value: "VendorType"
        }

    ]
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };
    const [Template, settemplate] = useState([]);
    const handleClick = event => {

    }
    const inputRef = useRef(null);
    const SubjectFieldClick = (event) => {
        const selectedTemplate = event?.value;
        if (inputRef.current) {
            const currentPosition = inputRef.current.selectionStart || 0;

            setSubject((prevSubject) => {
                return prevSubject.slice(0, currentPosition) + `[${selectedTemplate}]` + prevSubject.slice(currentPosition);
            });
            const caretPosition = currentPosition + selectedTemplate.length + 2; // 2 for the added square brackets
            inputRef.current.selectionStart = caretPosition;
            inputRef.current.selectionEnd = caretPosition;
            inputRef.current.focus();
        }
    };

    // const editorRef1 = useRef();
    // const SubjectFieldClick = (event) => {
    //     const selectedTemplate = event?.value;
    //     const editor = editorRef1.current;
    //     if (editor) {
    //         const currentPosition = editor.model.document.selection.getFirstPosition();
    //         editor.model.change((writer) => {
    //             writer.insertText(`[${selectedTemplate}]`, currentPosition);
    //         });
    //     }


    // }
    const [Info1, setInfo1] = useState();

    const editorRef = useRef();
    const BodyFieldClick = (event) => {
        const selectedTemplate = event?.value;
        setInfo1(selectedTemplate);
    };

    const onLoadQuill = () => {
        const quill = quillRef.current.getEditor();
        if (quill) {
            const currentPosition = quill.getSelection(true).index;
            quill.insertText(currentPosition, `[${Info1}]`);
        }
    };

    useEffect(() => {
        // Trigger onLoadQuill when Info1 changes
        onLoadQuill();
    }, [Info1]);


    const activeStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };
    const [files, setFiles] = useState([]);
    const [fileReset, setFileReset] = useState(true);
    const onDrop = useCallback(acceptedFiles => {
        setFiles(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        onDrop,
        accept: 'pdf',
        maxFiles: 1
    });

    const style = useMemo(() => ({

        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    const thumbs = files.map(file => (
        <div key={file.name}>
            {file.name}
        </div>
    ));
    // clean up
    useEffect(() => () => {
        files.forEach(file => URL.revokeObjectURL(file.name));
    }, [fileReset]);

    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };

    const [open, setOpen] = useState(false);
    const [Tab, setTab] = useState("");
    const [AttachId, setAttachId] = useState({});

    const handleClose = () => {
        setOpen(false);
    };
    const handleClickOpen = (num, data) => {
        setOpen(true);
        setTab(num);
        setAttachId(num == 2 ? data : "");
    };

    const [ClientList, setClientList] = React.useState([]);
    const [AttachList, setAttachList] = React.useState([]);
    const [clientId, setClientId] = React.useState("-2");
    const [TemName, setTemName] = useState("");
    const [subject, setSubject] = useState("");
    const [emailbody, setEmailbody] = useState("");
    const [Comment, setComment] = useState("");
    const [LanguageId, setLanguageId] = useState("0");
    const [Info, setInfo] = useState({});
    const [Dis, setDis] = useState(false);
    const [Dis1, setDis1] = useState(false);

    const { data: res } = useFetch("EmailTemplates/GetEmailTemplateDetailByTemplateId?emailTemplateID=" + DETAILS);
    useEffect(() => {
        if (ID != 1) {
            setInfo(res?.data);
            setTemName(res?.data?.name);
            setSubject(res?.data?.emailSubject);
            setEmailbody(res?.data?.emailBody);
            setComment(res?.data?.commentText);
            //setLanguageId(res?.data?.languageId);
        }
        else {
            setTemName("");
            setSubject("");
            setEmailbody("");
            setComment("");
            //setLanguageId("");
        }
        GetAllClients();
        GetAttachmentsList();
        if (ID == 3) {
            ChangeLanguage(0);
        }
    }, [res, SHOWS]);

    const ChangeLanguage = async (e) => {
        setLanguageId(e);
        const res = await axios.get("MyAccount/GetEmailData?EmailTemplateId=" + DETAILS + "&LanguageID=" + e);
        setInfo(res?.data?.data);
        setTemName(res?.data?.data?.name);
        setSubject(res?.data?.data?.emailSubject);
        setEmailbody(res?.data?.data?.emailBody);
        setComment(res?.data?.data?.commentText == null ? "" : res?.data?.data?.commentText);
    }



    async function GetAllClients() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=true");
        setClientList(res?.data?.data);
    }
    const ChangeBody = (data) => {
        setEmailbody(data);

    }
    const AddOrEdit = async (val) => {
        setDis(true);
        if (val == 1) {
            const Data = {
                "emailTemplateID": ID == 1 ? -1 : Info?.emailTemplateID,
                "emailUsedFor": ID == 1 ? 0 : Info?.emailUsedFor,
                "isClientSpecific": ID == 1 ? false : Info?.isClientSpecific,
                "clientOrganizationID": Info?.clientOrganizationID,
                "name": TemName,
                "emailSubject": subject,
                "emailBody": emailbody,
                "commentText": Comment,
                "insertDateTime": ID == 1 ? null : Info?.insertDateTime,
                "updateDateTime": ID == 1 ? null : Info?.updateDateTime,
                "isDocumentSpecific": ID == 1 ? null : Info?.isDocumentSpecific,
                "languageId": 0,
                "selectedLanguageIds": ""
            }
            const res = await axios.post("MyAccount/AddOrUpdateEmailTemplate", Data);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                TemplatesList();
                CLOSETAB();
                resetFields();
                setDis(false);
            } else {
                toastNotify(res?.data?.responseMessage, false);
                setDis(false);
            }
        } else {
            const Data = {
                "emailTemplateID": Info?.emailTemplateID,
                "emailUsedFor": Info?.emailUsedFor,
                "isClientSpecific": Info?.isClientSpecific,
                "clientOrganizationID": Info?.clientOrganizationID,
                "name": TemName,
                "emailSubject": subject,
                "emailBody": emailbody,
                "commentText": Comment,
                "insertDateTime": Info?.insertDateTime,
                "updateDateTime": Info?.updateDateTime,
                "isDocumentSpecific": Info?.isDocumentSpecific,
                "languageId": LanguageId,
                "selectedLanguageIds": ""
            }
            const res = await axios.post("MyAccount/SaveEmailData", Data);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                TemplatesList();
                CLOSETAB();
                resetFields();
                setDis(false);
            } else {
                toastNotify(res?.data?.responseMessage, false);
                setDis(false);
            }
        }

    }
    async function GetAttachmentsList() {
        const res = await axios.get("MyAccount/GetEmailAttachmentsList?templateId=" + DETAILS);
        setAttachList(res?.data);

    }
    const SaveOrDeleteAttachments = () => {
        setDis1(true);
        if (Tab == 1) {
            const formData = new FormData();
            formData.append("FileName", "");
            formData.append("EmailTemplateID", DETAILS);
            formData.append("AttachmentId", "00000000-0000-0000-0000-000000000000");
            formData.append("formFile", files[0]);
            axios.post("MyAccount/AddEmailAttachment", formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            ).then(res => {

                if (res?.data?.responseCode == 100 && res?.data?.data != "Please browse a file to upload") {
                    toastNotify(res?.data?.data, true);
                    setOpen(false);
                    GetAttachmentsList();
                    setFiles([]);
                    // handleClose();
                    setDis1(false);
                } else if (res?.data?.data == "Please browse a file to upload") {
                    toastNotify(res?.data?.data, false);
                    setDis1(false);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    setDis1(false);
                }
            }).catch(err => {
                console.log(err)
            })

        } else {
            axios.post("MyAccount/DeleteEmailAttachment?attachmentId=" + AttachId?.attachmentId + "&templateId=" + AttachId?.emailTemplateID)
                .then(resp => {
                    if (resp?.data?.responseCode == 100) {
                        toastNotify(resp?.data?.data, true);
                        setOpen(false);
                        GetAttachmentsList();
                        // handleClose();
                        setDis1(false);
                    } else {
                        toastNotify(resp?.data?.responseMessage, false);
                        setDis1(false);
                    }
                }).catch(err => {
                    console.log(err)
                })

        }
    }

    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const resetFields = () => {
        CLOSETAB();
        setTemName("");
        setSubject("");
        setEmailbody("");
        setComment("");
        setLanguageId("0");
    }


    const handleUndo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.undo();
    };

    const handleRedo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.redo();
    };
    const quillRef = React.createRef();

    return (
        <>
            {/* <ToastContainer /> */}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                <DialogContent sx={{ padding: "48px 48px" }}>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{Tab == 1 ? " Add Attachment " : " Delete Attachment "}</span>
                    </DialogTitle>

                    <DialogActions >
                        <div>
                            {Tab == 1 ?
                                <div>
                                    <div className="drop" {...getRootProps({ style })} style={{ padding: "20px" }} >
                                        <img className='mt-2' src={Logo} alt="" style={{ mixBlendMode: "diffrence" }} />
                                        <br />
                                        <input {...getInputProps()} />

                                        <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')} <span className=' text-muted Fs'>
                                            or drag and drop</span> </span>
                                        </b></span>
                                        <br />

                                        <span className=' text-muted Fs'> {thumbs}</span>
                                    </div>
                                </div>
                                : "Are you sure, you want to delete this attachment?"}

                            <DialogActions >
                                <div className="login-help__buttonContainer mt-4">
                                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={() => {
                                        handleClose()
                                        if (Tab == 1) {
                                            setFiles([]);
                                        }
                                    }}>Cancel</Button>
                                    {HasPermissions(INFO?.AddEmailAttachment?.actionName, PER?.ScreenPermissions?.Insert) &&
                                        <Button variant="contained" className="login-button-request mx-2" onClick={SaveOrDeleteAttachments}>{Tab == 1 ? "Add" : "Ok"}</Button>
                                    }
                                </div>

                            </DialogActions>
                        </div >
                    </DialogActions>



                </DialogContent>
            </Dialog>
            <Box sx={{ padding: "20px" }}>
                <p style={{ fontSize: "26px", fontWeight: '600' }}>{ID == 1 ? "Add Template" : "Edit Template"}</p>
                <Box sx={{ padding: "10px", backgroundColor: "#fff" }}>
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>

                        <Grid item xs={12} sm={12} md={7} >
                            <div hidden={ID != 3}>
                                <span style={{ fontSize: "14px" }}>
                                    Select Language
                                </span>
                                <br />
                                <Select
                                    sx={{
                                        '& legend': { display: 'none' },
                                        '& fieldset': { top: 0 },
                                    }}
                                    labelId="demo-multiple-name-label"
                                    value={LanguageId}
                                    fullWidth
                                    id="demo-multiple-name"
                                    size="small"
                                    onChange={(e) => ChangeLanguage(e.target.value)}
                                    MenuProps={MenuProps}
                                >
                                    {Languages?.map((r, i) =>
                                        <MenuItem key={i} value={r?.value} > {r?.text}</MenuItem>
                                    )}
                                </Select>
                            </div>
                            <br />

                            <div hidden={ID == 3}>
                                <span style={{ fontSize: "14px" }}>
                                    Client <span style={{ color: "red" }}>*</span>
                                </span>
                                <br />
                                <Select
                                    sx={{
                                        '& legend': { display: 'none' },
                                        '& fieldset': { top: 0 },
                                    }}
                                    labelId="demo-multiple-name-label"
                                    value={clientId || ""}
                                    fullWidth
                                    id="demo-multiple-name"
                                    size="small"
                                    onChange={(e) => setClientId(e.target.value)}
                                    MenuProps={MenuProps}
                                >
                                    <MenuItem key={0} value={"-2"} >Generic</MenuItem>
                                    {ClientList?.map((r, i) =>
                                        <MenuItem key={i} value={r?.value} > {r?.text}</MenuItem>
                                    )}
                                </Select>
                            </div>
                            <br />

                            <div hidden={ID == 3}>
                                <span style={{ fontSize: "14px" }}>Template Name <span style={{ color: "red" }}>*</span></span>
                                <br />
                                <TextField
                                    fullWidth
                                    placeholder="Template Name"
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        backgroundColor: "#fff",
                                        marginTop: "2px",
                                        marginBottom: "5px",
                                    }}

                                    variant="outlined"
                                    size="small"
                                    value={TemName || ""}
                                    onChange={(e) => setTemName(e.target.value)}

                                />
                            </div>
                            <br />

                            <div>
                                <span className="abc" style={{ fontSize: "14px" }}>
                                    Email Subject  <span style={{ color: "red" }}>*</span>
                                </span>
                                <br />
                                <TextField
                                    fullWidth
                                    placeholder="Subject"
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        backgroundColor: "#fff",
                                        marginTop: "2px",
                                        marginBottom: "5px",
                                    }}
                                    value={subject || ""}
                                    onChange={(e) => {
                                        setSubject(e.target.value);
                                    }}
                                    inputRef={inputRef}
                                    variant="outlined"
                                    size="small"
                                />
                            </div>
                            <br />

                            <div>
                                <span style={{ fontSize: "14px" }}>
                                    Email Body <span style={{ color: "red" }}>*</span>
                                </span>
                                {/* <CKEditor
                                    editor={ClassicEditor}
                                    data={emailbody || ""}
                                    onReady={(editor) => {
                                        editorRef.current = editor;
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor?.getData();
                                        ChangeBody(data);
                                        setEmailbody(data);
                                    }}
                                /> */}
                                <div>
                                    <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                                        <UndoIcon />
                                    </IconButton>
                                    <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                                        <RedoIcon />
                                    </IconButton>
                                    <ReactQuill
                                        ref={quillRef}
                                        theme="snow"
                                        modules={modules}
                                        formats={formats}
                                        value={emailbody}
                                        onChange={setEmailbody}
                                    />
                                </div>
                            </div>
                            <br />

                            <div hidden={ID != 2}>
                                <span className="abc" style={{ fontSize: "14px" }}>
                                    Attachments
                                </span>
                                <br />
                                {HasPermissions(INFO?.AddEmailAttachment?.actionName, "I") &&
                                    <Button disabled={Dis1} onClick={() => handleClickOpen(1, '')}>Add Attachments</Button>
                                }
                                <br />
                                {AttachList?.map((r, index) => (
                                    <div key={r.attachmentId}>
                                        <span>
                                            {r?.fileName}
                                            {HasPermissions(INFO?.AddEmailAttachment?.actionName, PER?.ScreenPermissions?.Delete) &&
                                                <CancelIcon
                                                    onClick={(e) => handleClickOpen(2, r)}
                                                    style={{ color: "red" }}
                                                />
                                            }
                                        </span>
                                    </div>
                                ))}

                            </div>
                            <br />

                            <div>
                                <span style={{ fontSize: "14px" }}>Add Comment</span>
                                <br />
                                <TextareaAutosize
                                    aria-label="minimum height"
                                    minRows={3}
                                    value={Comment}
                                    onChange={(e) => setComment(e?.target?.value)}
                                    placeholder="Add Comment..."
                                    style={{ width: "760px" }}
                                />
                            </div>
                            <br />
                        </Grid>

                        <Grid item xs={12} sm={14} md={5} >
                            <span style={{ fontSize: "20px", fontWeight: "500" }}>Email Subject Fields</span>
                            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }} />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }}
                                >
                                    <Typography>Database Fields</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {Emaildata?.map((r, i) => (
                                        <ListItem key={i} component="div" disablePadding >

                                            <ListItemButton hidden={r?.is == true && clientId != -2}

                                                onClick={e => {
                                                    if (e.detail === 1) handleClick(r);
                                                    if (e.detail === 1) SubjectFieldClick(r);

                                                }} >
                                                <ListItemText >{r.value} </ListItemText  >
                                            </ListItemButton>

                                        </ListItem>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                            < br />
                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }} />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                    sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }}
                                >
                                    <Typography>Invitation Fields</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {InvitationFields?.map((r, i) => (
                                        <ListItem key={i} component="div" disablePadding>

                                            <ListItemButton onClick={e => {
                                                if (e.detail === 1) handleClick(r);
                                                if (e.detail === 1) SubjectFieldClick(r);
                                            }}>
                                                <ListItemText  >{r.value} </ListItemText  >
                                            </ListItemButton>

                                        </ListItem>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                            <br />
                            <span style={{ fontSize: "20px", fontWeight: "500" }}>Email Body Fields</span>
                            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }} />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }}
                                >
                                    <Typography>Database Fields</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {Emaildata?.map((r, i) => (
                                        <ListItem key={i} component="div" disablePadding>

                                            <ListItemButton onClick={e => {
                                                if (e.detail === 1) handleClick(r);
                                                if (e.detail === 1) BodyFieldClick(r);
                                            }}>
                                                <ListItemText  >{r.value} </ListItemText  >
                                            </ListItemButton>

                                        </ListItem>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                            < br />
                            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }} />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                    sx={{ backgroundColor: "#DBEAF4", color: "#2A93DB" }}
                                >
                                    <Typography>Invitation Fields</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {InvitationFields?.map((r, i) => (
                                        <ListItem key={i} component="div" disablePadding>

                                            <ListItemButton onClick={e => {
                                                if (e.detail === 1) handleClick(r);
                                                if (e.detail === 1) BodyFieldClick(r);
                                            }}>
                                                <ListItemText  >{r.value} </ListItemText  >
                                            </ListItemButton>

                                        </ListItem>
                                    ))}
                                </AccordionDetails>
                            </Accordion>

                        </Grid>
                        <div className='mx-4'>
                            <Button variant="contained" sx={{ padding: "20px" }} onClick={resetFields}>Cancel</Button>
                        </div>
                        <div style={{ marginLeft: "Auto" }}>
                            {ID != 3 ?
                                <div>
                                    {HasPermissions(INFO?.AddOrEditEmailTemplate?.actionName, PER?.ScreenPermissions?.Insert) &&
                                        <Button disabled={Dis} variant="contained" sx={{ padding: "20px" }} onClick={() => AddOrEdit(1)}>Save</Button>
                                    }
                                </div>

                                : <div>
                                    {HasPermissions(INFO?.AddOrEditEmailTemplate?.actionName, PER?.ScreenPermissions?.Modify) &&
                                        <Button disabled={Dis} variant="contained" sx={{ padding: "20px" }} onClick={() => AddOrEdit(2)}>Save</Button>
                                    }
                                </div>
                            }
                        </div>
                    </Grid>
                </Box>
            </Box>
        </>
    )
}